package com.anjuros.website.templates.selection.util

import com.anjuros.website.templates.selection.modules.Theme
import org.jetbrains.compose.web.css.px


object Constants {
    const val FONT_FAMILY="Roboto"
    const val DEV_WEB = "https://www.anjurosdevelopment.com/"
    const val CLIENTS_EMAIL = "contact@anjurosdevelopment.com"
    const val CLIENTS_FB_NAME = "Anjuros Development"
    const val CLIENTS_WHATSAPP = "+44 7497599150"
    const val CLIENTS_WHATSAPP_LINK = "https://wa.me/+447497599150"
    const val CLIENTS_FB_LINK = "https://www.facebook.com/profile.php?id=61588143044175"


    val placeholderPrimaryColor = Theme.Primary
    val placeholderPrimaryColorOpacity = Theme.OpacityPrimary4
    val placeholderPrimaryColorOpacity2 = Theme.OpacityPrimary3

    val templateHeaderHeight = 60.px


}

object Res{
    object Icon {
        const val facebook = "facebook_icon.png"
        const val email = "email_icon.png"
        const val arrow_down = "arrow_down.svg"
        const val arrow_up = "arrow_up.svg"
        const val icon_x = "/icon_x.svg"
        const val icon_x_white = "/icon_x_white.svg"


    }
    object Image{
        const val logo = "/logoanjuros.PNG"
        const val flag_uk = "/flag_uk.svg"


        //templates

        const val template1_main="template1-main.webp"
        const val template2_main="template2-main.webp"
        const val template9_main="template9-main.jpeg"
        const val template4_main="template4-main.webp"
        const val template5_main="template5-main.jpeg"
        const val template6_main="template6-main.webp"
        const val template10_main="template10_main.jpg"
        const val template8_main="template8_main.jpg"
        const val templatemix_main="templatemix-main.jpeg"

    }
}
